import React, { FC } from "react";
import { Typography, Grid } from "@material-ui/core";
import styles from "./ErrorPage.module.scss";

const ErrorPage: FC = () => {
  return (
    <Grid className={styles.container} container justify="center" alignItems="center">
      <Grid item>
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          <Typography variant="h6">This page failed to load, please refresh and try again.</Typography>
          <Typography variant="h6">
            If the issue persists, please contact support at{" "}
            <a href="mailto:AISDevelopers@ausport.gov.au">AISDevelopers@ausport.gov.au</a>.
          </Typography>
        </div>
      </Grid>
    </Grid>
  );
};

export default ErrorPage;
